export const selectToken = ({ auth }) => auth.accessToken
export const selectCurrentUser = ({ auth }) => auth.user
export const selectIsAdmin = ({ auth }) => auth.admin
export const selectIsSupervisor = ({ auth }) => auth.supervisor
export const selectIsInvestigator = ({ auth }) => auth.investigator
export const selectIsLogout = ({ auth }) => auth.logout
